<script>
  import { Link } from "svelte-routing";
  import { onMount } from "svelte";

  let isMobileMenuOpen = false; // Track the state of mobile menu

  // Function to toggle the mobile menu
  function toggleMobileMenu() {
    isMobileMenuOpen = !isMobileMenuOpen;
  }

  // Close the mobile menu when a link is clicked
  function closeMobileMenu() {
    isMobileMenuOpen = false;
  }

  // Close the mobile menu when clicking outside of it
  function handleDocumentClick(event) {
    if (
      !event.target.closest(".nav-links") &&
      !event.target.closest(".mobile-menu-icon")
    ) {
      closeMobileMenu();
    }
  }

  onMount(() => {
    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  />
</svelte:head>
<nav>
  <div class="logo-container">
    <div class="logo"><img src="/img/logo.png" alt="IT Services" /></div>
  </div>

  <div class="mobile-menu-icon" on:click={toggleMobileMenu}>
    <span></span>
    <span></span>
    <span></span>
  </div>

  <div class="nav-links" class:open={isMobileMenuOpen}>
    <ul>
      <li><Link to="/" on:click={closeMobileMenu}>Home</Link></li>
      <li><Link to="/about" on:click={closeMobileMenu}>About</Link></li>
      <li><Link to="/service" on:click={closeMobileMenu}>Service</Link></li>
      <li><Link to="/contact" on:click={closeMobileMenu}>Contact</Link></li>
    </ul>
  </div>
</nav>

<style>
  nav {
    top: 0;
    left: 0;
    width: 97%;
    z-index: 1000; /* Ensure it is above other content */
    background-color: white;
    padding: 10px 20px;
    padding-bottom: 5px; /* Add padding to the bottom */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease;
    display: flex;
    justify-content: space-between;
    margin-right: 0px;
    align-items: center;
    border-bottom: 1px solid black;
    position: fixed;
  }

  nav.transparent {
    position: fixed;
    background-color: rgba(255, 255, 255, 0);
  }

  nav.no-border {
    border-bottom: none;
  }

  .logo-container {
    width: 20%; /* 20% width for the logo container */
    display: flex;
    align-items: center;
  }

  .logo {
    color: black;
    font-weight: bold;
  }

  .logo img {
    width: auto;
    height: 50px;
  }

  .nav-links {
    width: 60%; /* 80% width for the navigation links container */
    display: flex;
    align-items: center;
    margin-left: 200px;
  }

  .nav-links ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start; /* Align text to the left */
  }

  .nav-links li {
    margin-right: 20px;
    padding: 5px 10px;
  }

  /* Target the link within list items */
  .nav-links li :global(a) {
    color: #333333;
    text-decoration: none;
    font-family: "Bree Serif", serif;
    font-size: 1.3rem;
  }
  @media (min-width: 481px) and (max-width: 768px) {
    nav {
      width: 98%; /* Adjust width to match .nav-links container */
    }
    .nav-links {
      display: none; /* Hide the navigation links by default */
      position: fixed;
      top: 7%; /* Adjust the top position to push it below the logo */
      right: 0;
      margin-right: 1%;
      width: 30%;
      background-color: white;
      padding: 10px 0px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      z-index: 999; /* Ensure it appears above other content */
    }

    .nav-links.open {
      display: block; /* Display the navigation links when mobile menu is open */
    }

    .nav-links ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column; /* Stack the navigation links vertically */
    }

    .nav-links li {
      margin-bottom: 20px;
    }

    .mobile-menu-icon {
      display: block; /* Display the hamburger icon */
      margin-right: 5%;
      cursor: pointer; /* Change cursor to pointer for better UX */
    }

    /* Style for the hamburger icon */
    .mobile-menu-icon span {
      display: block;
      width: 30px;
      height: 3px;
      background-color: #333;
      margin-right: 1%;
      margin: 6px 0;
      transition: background-color 0.3s ease;
    }

    /* Animation for the hamburger icon */
    .mobile-menu-icon.open span:nth-child(1) {
      transform: rotate(45deg) translate(5px, 5px);
    }

    .mobile-menu-icon.open span:nth-child(2) {
      opacity: 0;
    }

    .mobile-menu-icon.open span:nth-child(3) {
      transform: rotate(-45deg) translate(5px, -5px);
    }
  }

  @media (max-width: 480px) {
    nav {
      width: 98%; /* Adjust width to match .nav-links container */
    }
    .nav-links {
      display: none; /* Hide the navigation links by default */
      position: fixed;
      top: 10%; /* Adjust the top position to push it below the logo */
      left: 0;
      margin-right: 1%;
      width: 50%;
      background-color: white;
      padding: 10px 0px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      z-index: 999; /* Ensure it appears above other content */
    }

    .nav-links.open {
      display: block; /* Display the navigation links when mobile menu is open */
    }

    .nav-links ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column; /* Stack the navigation links vertically */
    }

    .nav-links li {
      margin-bottom: 20px;
    }

    .mobile-menu-icon {
      display: block; /* Display the hamburger icon */
      margin-right: 8%;
      cursor: pointer; /* Change cursor to pointer for better UX */
    }
    /* Style for the hamburger icon */
    .mobile-menu-icon span {
      display: block;
      width: 30px;
      height: 3px;
      background-color: #333;
      padding-top: 2%;
      margin: 6px auto;
      transition: background-color 0.3s ease;
    }

    /* Animation for the hamburger icon */
    .mobile-menu-icon.open span:nth-child(1) {
      transform: rotate(45deg) translate(5px, 5px);
    }

    .mobile-menu-icon.open span:nth-child(2) {
      opacity: 0;
    }

    .mobile-menu-icon.open span:nth-child(3) {
      transform: rotate(-45deg) translate(5px, -5px);
    }
  }
</style>
